const compressImg = (file) => {
    let disposeFile = file;
    if (Object.prototype.toString.call(file) === '[object Blob]') {
      disposeFile = new File([file], file.name, { type: file.type });
    }
    const read = new FileReader();
    const _that = this;
    const fileSize = parseFloat(parseInt(disposeFile.size, 10) / 1024 / 1024).toFixed(2);
    // 小于1m不压缩
    if (fileSize < 1) return file;
    read.readAsDataURL(disposeFile);
    return new Promise((resolve, reject) => {
      try {
        read.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          // eslint-disable-next-line func-names
          img.onload = function() {
            const w = Math.floor(this.width / 2);
            const h = Math.floor(this.height / 2);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            let base64;
            canvas.setAttribute('width', w);
            canvas.setAttribute('height', h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize < 1) {
              // 如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(disposeFile.type, 1);
            } else if (fileSize > 1 && fileSize < 2) {
              // 如果图片大于1M并且小于2M 那么压缩0.5
              base64 = canvas.toDataURL(disposeFile.type, 0.5);
            } else {
              // 如果图片超过2m 那么压缩0.2
              base64 = canvas.toDataURL(disposeFile.type, 0.2);
            }
            resolve(dataURLtoFile(base64, disposeFile.name));
          };
        };
      } catch (error) {
        reject(disposeFile);
      }
    });
  };

  //1,先将base64转换为blob
  const dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  //2,再将blob转换为file
  const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
    theBlob.name = fileName; // 文件名
    return new File([theBlob], fileName, { type: theBlob.type, lastModified: Date.now() });
  };

  // 使用示例
  const dataURLtoFile = (file, fileName) => {
    // 1.先转为 blob格式  file.content是此文件的base64格式
    let blob = dataURLtoBlob(file);
    let file1 = blobToFile(blob, fileName);
    return file1;
  };

  export default compressImg;